








import { Vue, Component, Prop } from 'vue-property-decorator'
import about from '@/assets/data/ja/about.json'

export type Texts = typeof about

@Component
export default class Itemize extends Vue {
  @Prop() private texts!: Texts
}
